module.exports = __webpack_public_path__ + "img/Circulo-Logo-DesarrolloSoftware-selected.e6ad67db.png";